import { default as TealiumTrackPage } from './tealium-track-page';
export default TealiumTrackPage;
